import { useState } from "react";
import {
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
  MessageBarActions,
  Button,
  makeStyles,
  Title3,
  Caption1,
} from "@fluentui/react-components";

import { AlertWithUser } from "../../Types/alert";
import AlertTable from "./AlertTable";
import AlertModal from "../AlertModal";
import useAlertManagement from "../../Hooks/useAlertManagement";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  filtersSection: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  tableSection: {
    flex: 1,
  },
});

const AlertManagementPage: React.FC = () => {
  const styles = useStyles();
  const [selectedAlert, setSelectedAlert] = useState<AlertWithUser | null>(
    null
  );

  const {
    alerts,
    totalCount,
    queryState,
    currentPage,
    totalPages,
    isLoading,
    error,
    setPage,
    setPageSize,
    updateSorting,
    refresh,
    updateAlert,
    updateAlertStatus,
    deleteAlert,
  } = useAlertManagement();


  const handleEdit = (alert: AlertWithUser) => {
    setSelectedAlert(alert);
  };

  const handleCloseModal = () => {
    setSelectedAlert(null);
  };

  const handleUpdateStatus = async (alert: AlertWithUser) => {
    await updateAlertStatus(alert.AlertId, !alert.IsActive);
  };

  const handleDelete = async (alert: AlertWithUser) => {
    const confirmed = globalThis.confirm(
      `Are you sure you want to delete the alert "${alert.AlertTitle}"?`
    );
    if (!confirmed) {
      return;
    }

    await deleteAlert(alert.AlertId);
  };

  return (
    <div className={styles.container}>
      {error && (
        <MessageBar intent="error">
          <MessageBarBody>
            <MessageBarTitle>Unable to load alerts</MessageBarTitle>
            {error.message}
          </MessageBarBody>
          <MessageBarActions>
            <Button appearance="primary" onClick={refresh}>
              Retry
            </Button>
          </MessageBarActions>
        </MessageBar>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Title3>Alerts</Title3>
        <Caption1>{totalCount} total</Caption1>
      </div>

      {/* <div className={styles.filtersSection}>
        <AlertFilters
          filters={filtersForSidebar}
          isBusy={isLoading}
          onApply={handleApplyFilters}
          onReset={handleResetFilters}
        />
      </div> */}

      <div className={styles.tableSection}>
        <AlertTable
          alerts={alerts}
          totalCount={totalCount}
          currentPage={currentPage}
          totalPages={totalPages}
          pageSize={queryState.limit}
          isLoading={isLoading}
          sortOrder={queryState.orderBy}
          onEdit={handleEdit}
          onUpdateStatus={handleUpdateStatus}
          onDelete={handleDelete}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
          onSortChange={updateSorting}
        />
      </div>

      {selectedAlert && (
        <AlertModal
          alert={selectedAlert}
          isOpen={Boolean(selectedAlert)}
          onClose={handleCloseModal}
          onSave={async (updatedAlert) => {
            await updateAlert(updatedAlert);
            handleCloseModal();
          }}
          title={`Edit alert: ${selectedAlert.AlertTitle}`}
        />
      )}
    </div>
  );
};

export default AlertManagementPage;
